import React, { Component } from "react";

import { Form, Button, Input, Checkbox, Row, Col, Spin, Select } from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import DriverGroupStore from "../store/DriverGroupStore";
import withRouter from "../withRouter";

import CompanyAutocomplete from "./CompanyAutocomplete";

import CompanyStore from "../store/CompanyStore";
import DriversStore from "../store/DriversStore";
import config from "../config";

const CheckboxGroup = Checkbox.Group;

class DriverGroupAdd extends Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            showAsset: false,
            selectedChecked: false,
            selectedValues: [],
            drgId: "",
            companyId: "",
            loadingSpin: false,
            driverId: '',
        };
        this.groupStore = new DriverGroupStore();
        this.companyStore = new CompanyStore();
        this.driverStore = new DriversStore();

    }
    async componentDidMount() {
        if (
            Number(this.props.getUserData().isadmin) !== -1 &&
            Number(this.props.getUserData().isadmin) !== 3
        ) {
            this.context.viewStateStore.setDriverGroupStates({
                companyId: this.props.getUserData().userCompanyId,
            });
            await this.setState({
                companyId: this.props.getUserData().userCompanyId,
            });
            await this.setState({ isadmin: this.props.getUserData().isadmin });

            await this.driverStore.toGetDriverName(
                this.props.getUserData().userCompanyId
            );

            await this.setState({ update: 1 });
        }
        const drgId = this.props.drgId;
        console.log("object", this.props)
        if (drgId) {
            await this.filldata(drgId);
            await this.setState({ drgId: drgId });
        }
    }

    filldata = async (drgId) => {
        console.log("object", this.props)
        await this.setState({ loadingSpin: true });
        const getDriverGroup = await this.groupStore.getDriverGroupData(
            drgId,
            this.props.companyId
        );

        const singleData = await this.companyStore.getCompanyDataById(
            this.props.companyId
        );
        let driverResp = await this.driverStore.toGetDriverName(
            this.props.companyId
        );

        await this.setState({
            companyId: getDriverGroup.companyId,
            drgId: getDriverGroup.drgId,
        });

        if (getDriverGroup.drivers.length === this.driverStore.getDriverName.length) {
            this.setState({ selectedChecked: true });
        }


        await this.formRef.current.setFieldsValue({
            drgId: getDriverGroup.drgId,
            companyId: singleData,
            groupName: getDriverGroup.groupName,
            driverId: getDriverGroup.drivers
                ? getDriverGroup.drivers.map((item) => Number(item.driverId))
                : []
        });
        await this.setState({ loadingSpin: false });
    };

    onDeviceDetailsSubmit = async (values) => {
        this.setState({ loading: true });
        console.log(values)
        const data = {
            ...values,
            companyId: this.state.companyId,
            drgId: this.state.drgId,
        };
        console.log(data);
        const resp = await this.groupStore.addData(data);
        await this.props.response(resp);

        this.setState({ loading: false });
    };

    async handleChange(comp) {
        await this.setState({ companyId: comp.value });
        if (!this.props.driverGroupId) {
            this.context.viewStateStore.setDriverGroupStates({
                companyId: comp.value,
            });
        }
        await this.formRef.current.setFieldsValue({
            companyId: this.state.companyId,
        });
        await this.driverStore.toGetDriverName(comp.value);
        this.setState({ update: 1 });

        const data = await this.groupStore.getAssetData(this.state.companyId);
        console.log("data", data);
        // await this.handleSearch();
    }

    async handleSearch() {
        await this.groupStore.loadData({
            offset: (this.state.currentPage - 1) * this.state.pageSize,
            limit: this.state.pageSize,
            searchField: this.state.searchField,
            companyId: this.state.companyId,
        });
        await this.setState({ loadList: 1 });
    }

    handleSelectAllChange = async (e) => {
        this.setState({ selectedChecked: e.target.checked });

        if (e.target.checked) {
            const allValues = this.groupStore?.driverList.map(
                (option) => option.vehicleId
            );
            this.formRef.current.setFieldsValue({ vehicle: allValues.vehicleNo });

            await this.setState({ selectedValues: allValues });
        } else {
            await this.setState({ selectedChecked: e.target.checked });
            await this.setState({ selectedValues: [] });
        }
    };



    closeModal = () => {
        this.props.closeModal();
    };

    render() {
        return (
            <div style={{ padding: 0 }}>
                <div>
                    <Spin spinning={this.state.loadingSpin} fullscreen>
                        <Form
                            style={{ maxWidth: "100%", padding: 0 }}
                            layout="vertical"
                            ref={this.formRef}
                            onFinish={this.onDeviceDetailsSubmit}
                            name="nest-message"
                            className="formClass" //change
                        >
                            <Row className="overflowFormInputs">
                                <Col span={24} className="formColumnClass">
                                    {/* css class */}
                                    {(this.props.getUserData().isadmin === -1 ||
                                        this.props.getUserData().isadmin === 3) && (
                                            <Form.Item
                                                name="companyId"
                                                label={this.context.translate("_ACCOUNT_")}
                                                rules={[{ required: true }]}
                                            >
                                                <CompanyAutocomplete
                                                    onChange={(value) => this.handleChange(value)}
                                                    style={{ width: "100%" }}
                                                />
                                            </Form.Item>
                                        )}

                                    <Form.Item
                                        name="groupName"
                                        label={this.context.translate(
                                            "_FLEET_GROUP_GROUPDETAIL_DEVICEGROUP_"
                                        )}
                                        rules={[{ required: true }]}
                                    >
                                        <Input />
                                    </Form.Item>


                                    <Form.Item label=" ">
                                        <Checkbox
                                            checked={this.state.selectedChecked}

                                            onChange={(e) => {
                                                const checked = e.target.checked;

                                                if (checked) {
                                                    const allDrivers = (this.driverStore?.getDriverName || []).map(
                                                        (d) => d.driverId
                                                    );

                                                    this.formRef.current?.setFieldsValue({
                                                        driverId: allDrivers,
                                                    });

                                                    this.setState({
                                                        selectedDrivers: allDrivers,
                                                        selectedChecked: true,
                                                    });
                                                } else {
                                                    this.formRef.current?.setFieldsValue({
                                                        driverId: [],
                                                    });

                                                    this.setState({
                                                        selectedDrivers: [],
                                                        selectedChecked: false,
                                                    });
                                                }
                                            }}
                                        >
                                            Select All Drivers
                                        </Checkbox>
                                    </Form.Item>
                                    <Form.Item
                                        style={{ width: "100%", height: "80px" }}
                                        className="search-field"
                                        value={this.state.driverId}
                                        name="driverId"
                                        label={this.context.translate("_DRIVER_NAME_")}
                                        rules={[{ required: true }]}
                                    >
                                        <Select
                                            mode="multiple"
                                            maxTagCount="responsive"
                                            placeholder={this.context.translate("_SELECT_DRIVER_")}
                                            showSearch
                                            fieldNames={{ value: "driverId", label: "name" }}
                                            optionFilterProp="children"
                                            options={this.driverStore?.getDriverName}
                                            filterOption={(input, option) => {
                                                // console.log(input, option);
                                                if (!option?.name) return false;

                                                const label = option.name
                                                    .toString()
                                                    .toLowerCase()
                                                    .replace(/\s+/g, "");

                                                const search = input
                                                    .toLowerCase()
                                                    .replace(/\s+/g, "");

                                                return label.includes(search);
                                            }}
                                        />
                                    </Form.Item>


                                </Col>

                            </Row>
                            <div className="formBtnGroup">
                                <Button
                                    type="primary"
                                    className="formCancelButton"
                                    onClick={(e) => {
                                        // this.formRef.current?.resetFields();
                                        this.closeModal();
                                        this.setState({
                                            selectedChecked: false,
                                            selectedValues: [],
                                        });
                                    }}
                                >
                                    {this.context.translate("_FLEET_CLOSE_BTN_")}
                                </Button>
                                <Button
                                    type="primary"
                                    className="formSaveButton"
                                    htmlType="submit"
                                    loading={this.state.loading}
                                >
                                    {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
                                </Button>
                            </div>
                        </Form>
                    </Spin>
                </div>
            </div>
        );
    }
}

DriverGroupAdd.contextType = StoreContext;
export default observer(withRouter(DriverGroupAdd));
